import { render, staticRenderFns } from "./PortfolioAccessDenied.vue?vue&type=template&id=609fc491&scoped=true&"
import script from "./PortfolioAccessDenied.vue?vue&type=script&lang=js&"
export * from "./PortfolioAccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioAccessDenied.vue?vue&type=style&index=0&id=609fc491&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fc491",
  null
  
)

export default component.exports